export default __webpack_public_path__ + "static/media/fecha-examen.e8056c11.svg";